import { http } from '../../config/axios'

export default function getRegistroTipoEmail(): Promise<any> {
  return http
    .get('api/registro/tiposemail/')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getRegistroTipoEmail', error)
      throw Error(error.response.data)
    })
}
